export default "__VITE_ASSET__Ca$ueb4___"